module.exports = __webpack_public_path__ + "static/media/letter_u.2c9b7cc6.svg";